<template>
<div id="deals">

    <v-tabs v-model="tab" @change="resumeSubscription(tab)" class="pl-4" v-show="!verifyPasswordDialog">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="(s, index) in sArr" :key="index" :href="'#'+s.name" class="primary--text text-capitalize">
            <span :style="`color:${Constants.DealStatusColor[s.status[0]]}`">
                {{ s.label }} ({{ $data[s.name + 'Count'] }})
            </span>
        </v-tab>
    </v-tabs>

    <!-- <v-card height="40" class="elevation-0 px-8 my-6"> -->
    <div class="btn-header mt-4" v-show="!verifyPasswordDialog">
        <v-row class="defaultgroup" :class="checkedItems.length||bulkSelectAll?'transform-hideview':''">
            <v-col class="pt-1" cols="auto">
                <v-text-field clearable label="Search" outlined @input="onSearch" hide-details/>
            </v-col>
            <datePicker class="pt-1" :initial="initialDate" @date="date=$event" @isLastNDays="isLastNDays=$event"
                        :appendToBody="true" opens="right" /><v-spacer/>
            <v-checkbox class="contain-note-checkbox" v-model="showDealsContainingNote" label="Deals Containing Note"/>
        </v-row>
        <BulkActionDeal :filter="bulkFilter" @onCancelSelect="onChangeSelectAll($event)" @showToast="toaster=$event"
                        class="checkedgroup" :class="checkedItems.length||bulkSelectAll?'transform-showview':''"/>
    </div>
   <!-- </v-card> -->

    <v-tabs-items v-model="tab" class="px-4" v-show="!verifyPasswordDialog">
        <v-tab-item v-for="(s, index) in sArr" :key="index" :value="s.name">  <!-- :loading="$apollo.queries[s.name].loading" -->
            <v-data-table :headers="headers[s.name]"
                          :footerProps="footerProps" class="elevation-0 deals-table" fixed-header height="calc(100vh - 280px)"
                          :items="$data[s.name]" :server-items-length="$data[s.name+'Count']"
                          :sort-by.sync="$data[s.name+'Options'].sortBy" :sort-desc.sync="$data[s.name+'Options'].sortDesc"
                          :options.sync="$data[s.name+'Options']" @update:options="onUpdateOptions">
                <template v-slot:no-data>No Deal Available</template>
                <template v-slot:no-results>No Deal Request Available</template>
                <template v-slot:header.checkbox="{}">
                    <v-checkbox v-model="bulkSelectAll" @click.stop="onChangeSelectAll(uncheckedItems.length>0||!bulkSelectAll)"
                                :indeterminate="!!(checkedItems.length||uncheckedItems.length)"/>
                </template>
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item, index) in items" :key="'row'+index" @click="rowClick(item)" :class="item.checked?'checked-row':''">
                        <td><v-checkbox v-model="item.checked" :class="item.checked?'check-icon checked':'check-icon'" @click.stop="onCheck(item)"/></td>
                        <td>
                            <v-menu offset-y :close-on-content-click="false" v-model="item.menu">
                                <template v-slot:activator="{ on:menu}">
                                    <v-btn v-on="{...menu}" icon><v-icon :style="`color:${Constants.DealStatusColor[item.statusId]}`">mdi-checkbox-blank</v-icon></v-btn>
                                </template>
                                <v-list dense v-show="![Constants.DealStatuses.Approved, Constants.DealStatuses.Rejected].includes(item.statusId)">
                                    <v-progress-linear :indeterminate="updateStatusLoading" absolute bottom></v-progress-linear>
                                    <v-list-item-group color="primary">
                                        <v-list-item v-for="(s, idx) in statuses" @click="onSelectStatus(item, s.id)" :key="'status'+idx">
                                            <v-list-item-icon>
                                                <v-icon :style="`color:${Constants.DealStatusColor[s.id]}`" >mdi-checkbox-blank</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>{{s.status}}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{item.dealNumber || '-'}}</td>
                        <td>
                            <div class="d-flex align-center">
                                <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" title="View Image"
                                          @click.stop="openGallery(([{path: item.Customer.profileImage, type: 'IMAGE'}]))">
                                    <v-img v-if="item.Customer.profileImage" :src="imgWpx(item.Customer.profileImage, 200)"
                                           alt="image" @error="item.Customer.profileImage = null">
                                        <template v-slot:placeholder>
                                            <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                            <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"/>
                                        </template>
                                    </v-img>
                                    <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                                </v-avatar>
                                <span class="c-name ellipsis" :title="item.Customer.name">
                                    <span :title="item.Customer.name">{{ item.Customer.name}}</span><br>
                                    <span class="f-12 grey--text text--darken-1">{{item.Customer.mobile}}</span>
                                </span>
                            </div>
                        </td>
                        <td>
                            <v-btn icon>
                                <v-icon v-if="item.Customer.city === null" title="NA" class="yellow--text text--darken-3">
                                    mdi-star-half-full
                                </v-icon>
                                <v-icon v-else-if="item.Customer.city.toLowerCase().trim() === 'surat'" title="Surat">
                                    mdi-star-outline
                                </v-icon>
                                <v-icon v-else class="yellow--text text--darken-3" :title="item.Customer.city">mdi-star</v-icon>
                            </v-btn>
                        </td>
                        <td>{{ item.DealItems_aggregate.aggregate.count }}</td>
                        <td>{{moment(item.created_at).format('DD MMM YYYY hh:mm A') }}</td>
                        <td v-if="s.name === 'approvedDeals'">{{item.approved_at?moment(item.approved_at).format('DD MMM YYYY hh:mm A'):'-'}}</td>
                        <td v-if="s.name === 'rejectedDeals'">{{item.rejected_at?moment(item.rejected_at).format('DD MMM YYYY hh:mm A'):'-'}}</td>
                        <td><v-btn icon v-if="item.note">
                            <v-tooltip right transition="fade-transition"><template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-note-text-outline</v-icon>
                            </template><span>{{item.note}}</span></v-tooltip>
                        </v-btn>
                        <td>
                            <v-menu nudge-bottom="25">
                                <template v-slot:activator="{ on:menu }">
                                    <v-btn small icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="openAddNote(item)"><v-list-item-title>{{item.note?'Edit':'Add'}} Note</v-list-item-title></v-list-item>
                                    <v-list-item @click="onDeleteDeal(item)"><v-list-item-title>Delete Deal</v-list-item-title></v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                    <tr v-if="!items.length" class="v-data-table__empty-wrapper"><td :colspan="headers[s.name].length">No Deals Available</td></tr>
                  </tbody>
                </template>
            </v-data-table>
        </v-tab-item>
    </v-tabs-items>

    <DealNoteForm :dialog.sync="addNoteDialog" :dealId.sync="dealId"/>
    <DealDetail :dialog.sync="dealDetailDialog" :id.sync="dealId"/>
    <verify-password-popup :dialog="verifyPasswordDialog" @update:dialog="onUpdatePasswordDialog"/>
    <Snackbar :toaster="toaster"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <gallery id="gallery-deal-list" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import {debounce} from 'lodash';
import gallery from '../../mixins/gallery';
import updateRecord from '../../mixins/updateRecord';
import {generate_FETCH_DEALS, generate_SUBSCRIBE_DEALS_COUNT} from "../../graphql/subscriptions/Deals";
import Snackbar from "../../components/Common/Snackbar";
import DatePicker from "../../components/Common/datePicker";
import {GET_DEAL_STATUS} from "../../graphql/queries/Deals";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
import {DELETE_DEAL_AND_DEAL_ITEMS_BY_ID} from "../../graphql/mutations/Deals";
import DealNoteForm from "./DealNoteForm";
import DealDetail from "./DealDetail";
import BulkActionDeal from "./BulkActionDeal";
import Vue from "vue";
import VerifyPasswordPopup from "../Security/VerifyPasswordPopup";
let sArr = [
    {name: 'pendingDeals', status: [Constants.DealStatuses.Pending], label: 'Pending Deals'},
    {name: 'approvedDeals', status: [Constants.DealStatuses.Approved], label: 'Approved Deals'},
    {name: 'rejectedDeals', status: [Constants.DealStatuses.Rejected], label: 'Rejected Deals'},
];
let qObj = {}, sObj = {}, options = {page: 1, itemsPerPage: 25, offset: 0, limit: 25, sortBy: ['created_at'], sortDesc: [true]};
function commonVariables(s)  {
    return {
        statusId: s.status,
        search: this.search,
        noteExp: this.showDealsContainingNote? {_is_null: false} : {},
        startDate: moment(this.date.startDate, 'YYYY-MM-DD').startOf('day'),
        endDate: moment(this.date.endDate, 'YYYY-MM-DD').endOf('day'),
    }
}
function pageVariables(s) {
    return {
        orderBy: this.prepareSortObject(this[s.name + 'Options'].sortBy, this[s.name + 'Options'].sortDesc),
        offset: this[s.name + 'Options'].offset, limit: this[s.name + 'Options'].limit
    }
}

sArr.forEach(s => {
   /* qObj[s.name] = {                                                          // Smart Query
        query() {return generate_FETCH_DEALS(s.name, 'query')},
        skip() {return s.name !== 'pendingDeals'},
        fetchPolicy: 'network-only',
        variables() { return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
        subscribeToMore: {
            document() {return generate_FETCH_DEALS(s.name, 'subscription')},
            variables() {return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
            updateQuery: function(previousQueryResult, {subscriptionData: {data}}) {
                this[s.name] = data[s.name];
                console.log('subsc data '+s.name , data[s.name])
            }
        },
        result({data}) { this[s.name] = data[s.name]; console.log('query data '+s.name , data[s.name])},
    }; */
    sObj[s.name] = {
        query() { return generate_FETCH_DEALS(s.name, 'subscription') },
        skip() {return s.name !== 'pendingDeals'},
        variables() {return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
        result({data}) { this[s.name] = data[s.name];
                         if(this.tab === s.name) this.afterFetchingDeals() },
    };
    sObj[s.name + 'Count'] = {
        query() { return generate_SUBSCRIBE_DEALS_COUNT(s.name + 'Count') },
        variables() { return {...commonVariables.call(this, s)}},
        result({data}) { this[s.name + 'Count'] = data[s.name + 'Count'].aggregate.count },
    };
});
export default {
    name: "Deals",
    components: {VerifyPasswordPopup, BulkActionDeal, DealDetail, DealNoteForm, ConfirmationDialog, DatePicker, Snackbar},
    mixins: [gallery, updateRecord],
    apollo:{
        $subscribe: {...sObj},
        ...qObj,
        statuses: { query: GET_DEAL_STATUS }
    },
    data(){
        return{
            Constants, moment,
            user: JSON.parse(localStorage.user),
            tab: 'pendingDeals',
            sArr: sArr,
            search: '%%',
            ...sArr.reduce((ac, s) => {ac[s.name] = []; ac[s.name + 'Count'] = 0; ac[s.name + 'Options'] = {...options}; return ac}, {}),    // newOrders: []
            columns: [
                {text: '', value: 'checkbox', width: 10, sortable:false},
                {text: 'STATUS', value: 'statusId'},
                {text: 'DEAL ID', value: 'dealNumber'},
                {text: 'CUSTOMER', value: 'customerName', width:240},
                {text: 'City', value: 'city', /*width: 10*/},
                {text: 'TOTAL PRODUCT', value: 'itemsCount'},
                {text: 'CREATED ON', value: 'created_at', width:172},
                {text: 'NOTE', value: 'note'},
                { text: 'ACTION', value: 'action', sortable:false}
            ],
            headers: {pendingDeals:[], approvedDeals:[], rejectedDeals:[]},
            footerProps: {'items-per-page-options': [25, 100, 150, 200, -1]},
            date: {startDate: moment(), endDate: moment()},
            initialDate: {startDate: moment().toDate(), endDate: moment().toDate()},
            isLastNDays: false,
            showDealsContainingNote: false,
            toaster: {},
            confirm: {enable: false},
            updateStatusLoading: false,
            statuses: [],
            dealDetailDialog: false,
            dealId: null,
            addNoteDialog: false,
          /* ----- Bulk Action ----- */
            checkedItems: [],
            uncheckedItems: [],
            bulkSelectAll: false,
          /* -------x-------x------- */
            verifyPasswordDialog: true
        }
    },
    computed:{
        bulkFilter(){
            let variables = JSON.parse(this.$apollo.subscriptions[this.tab + 'Count'].previousVariablesJson);
            return  {ids: this.bulkSelectAll?'ALL':this.checkedItems, uncheckedIds:this.uncheckedItems, allCount:this[this.tab + 'Count'], variables};
        },
    },
    methods:{
        afterFetchingDeals(){
            if(this.bulkSelectAll) this[this.tab].forEach(v => this.uncheckedItems.includes(v.id) || Vue.set(v, 'checked', true));
            else if(this.checkedItems.length) this[this.tab].forEach(v => this.checkedItems.includes(v.id) && Vue.set(v, 'checked', true));
        },
        onCheck(row){
            Vue.set(row, 'checked', !row.checked);
            if(row.checked && this.bulkSelectAll) this.uncheckedItems.splice(this.uncheckedItems.indexOf(row.id), 1);
            else if(!row.checked && this.bulkSelectAll) this.uncheckedItems.push(row.id);
            else if(row.checked  && !this.bulkSelectAll) this.checkedItems.push(row.id);
            else if(!row.checked && !this.bulkSelectAll)this.checkedItems.splice(this.checkedItems.indexOf(row.id), 1);
            if(this.uncheckedItems.length === this.bulkFilter.allCount) this.onChangeSelectAll(false)
            else if(this.checkedItems.length === this.bulkFilter.allCount) this.onChangeSelectAll(true)
            //this.bulkSelectAll = false                                 /* Reset value */
        },
        onChangeSelectAll(value){
            this.bulkSelectAll = value;
            this[this.tab].forEach(v => Vue.set(v, 'checked', value));
            /*if(value) this.checkedItems = this.customers.map(c => c.id)*/
            this.checkedItems = [];                                         /* Reset value */
            this.uncheckedItems = [];                                       /* Reset value */
        },
        rowClick(row) {
          this.dealId = row.id;
          this.dealDetailDialog = true;
        },
        async onSelectStatus(row, statusId){
            if(statusId === row.statusId || [Constants.DealStatuses.Approved, Constants.DealStatuses.Rejected].includes(row.statusId)) return;
            this.updateStatusLoading = true;
            let obj = { statusId, updatedBy:this.user.id };
            if(statusId === Constants.DealStatuses.Approved) obj['approved_at'] = moment().format();
            if(statusId === Constants.DealStatuses.Rejected) obj['rejected_at'] = moment().format();
            await this.updateRecord(row.id, obj, 'Deals');
            this.updateStatusLoading = false;
            Vue.set(row, 'menu', false);
            this.toaster = {enable:true, color:'green', message: `Deal Status Updated Successfully`};
        },
        openAddNote(row){
            this.dealId = row.id;
            this.addNoteDialog = true;
        },
        onDeleteDeal(row){
            this.confirm = {enable:true, message:'Are you sure want to delete Deal?',
                row, method:this.deleteDeal, closeMethod:this.closeConfirmPopup};
        },
        async deleteDeal(){
                let response = await this.$apollo.mutate({
                mutation: DELETE_DEAL_AND_DEAL_ITEMS_BY_ID,
                variables: { id: this.confirm.row.id }
            });
            if(response.data) {
                this.toaster = {color: 'green', enable: true, message: `Deal deleted Successfully`};
                this.closeConfirmPopup();
            }
        },
        closeConfirmPopup(){
            this.confirm = {enable: false};
        },
        prepareSortObject([sortBy], [order]) {
            order = order ? 'desc' : 'asc';
            if (['created_at', 'dealNumber', 'approved_at', 'rejected_at'].includes(sortBy)) return {[sortBy]: order};
            if (sortBy === 'note') return {[sortBy]: (order === 'desc'?'desc_nulls_last':'asc_nulls_first')};
            if (sortBy === 'customerName') return {Customer: {name: order}};
            if (sortBy === 'itemsCount') return {DealItems_aggregate: {count: order}};
            return null
        },
        async resumeSubscription(tab) {
            /* On tab change, reset all bulk action variables */
            this.onChangeSelectAll(false);
            setTimeout(() => this.$apollo.subscriptions[tab].skip = false, 500)
        },
        onUpdateOptions(val) {
            if (val.itemsPerPage === -1) {                                         //'ALL' Rows per page
                this[this.tab + 'Options'].limit = this[this.tab + 'Count'];          //assign total count
                this[this.tab + 'Options'].offset = 0
            } else {
                this[this.tab + 'Options'].limit = val.itemsPerPage;
                this[this.tab + 'Options'].offset = (val.page - 1) * val.itemsPerPage;
            }
        },
        onSearch: debounce(async function (val) {
            this.search = val ? ('%' + val + '%') : '%%';
            sArr.forEach(s => this[s.name + 'Options'] = {...options})          //on search, reset page options
        }, 500),
        onUpdatePasswordDialog(val){
            this.verifyPasswordDialog = val;
            if(this.$route.params.id) this.rowClick({id: this.$route.params.id});
        }
    },
    async created() {
        this.headers['pendingDeals'] = this.columns;
        this.headers['approvedDeals'] = [...this.columns.slice(0, 7), {text:'APPROVED ON', value:'approved_at'} ,...this.columns.slice(7)];
        this.headers['rejectedDeals'] = [...this.columns.slice(0, 7), {text:'REJECTED ON', value:'rejected_at'} ,...this.columns.slice(7)];
    }
}
</script>

<style scoped>
#deals{
    padding: 10px;
}
/deep/ .vue-daterange-picker .dropdown-menu {
    top: 40px;
}

/deep/ .reportrange-text {
    /*width: 212px;*/
    text-align: center;
    padding: 14px 10px;
    border: 1px solid rgba(0, 0, 0, .14);
    margin: 0 0 0 6px;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.c-name {
    display: inline-block;
    vertical-align: middle;
    width: 120px;
    max-width: 120px;
}
.deal-number {
    display: inline-block;
    vertical-align: middle;
    width: 70px;
    max-width: 70px;
}
.contain-note-checkbox{
    margin: 4px 14px 0 4px;
}
.deals-table{
    /*margin: -30px 0 0 0;*/
    cursor: pointer;
}
/deep/ .deals-table tbody tr .check-icon .v-icon{
    opacity: 0.2;
}
/deep/ .deals-table tbody tr .checked .v-icon{
    opacity: unset;
}
/deep/ .deals-table tbody tr:hover .check-icon .v-icon{
    opacity: unset;
}
/deep/ .deals-table tbody tr.checked-row{
    background: #eff2f5;
}
/* ---- Bulk Action Styles ---- */
.btn-header{
    height: 70px;
    overflow: hidden;
    padding: 0 20px 0 20px;
}
.btn-header .defaultgroup{
    transform: translateY(0);
    transition: .4s cubic-bezier(.55,.06,.68,.19);
}
.btn-header .checkedgroup{
    transform: translateY(110%);
    transition: .4s cubic-bezier(.55,.06,.68,.19);
}
.transform-hideview{                   /* To hide defaultgroup */
    transform: translateY(-190%) !important;
}
.transform-showview{                   /* To show checkedgroup */
    transform: translateY(-140%) !important;
}
/* ---------x---------x-------- */
</style>